import { createContext } from 'react';

const mainContext = createContext();

export default mainContext;